import { DismissablePromptKey, Experiment } from '@ms/yammer-data/dist/state/types';
import { useShouldStartDismissablePrompt } from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

export const useShouldDisplayVivaEngageNonAdminRebrandingBanner = () => {
  const isRegularBannerExperimentEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebrandingBanner) === 'enabled';
  const shouldStartRegularBannerPrompt = useShouldStartDismissablePrompt(
    DismissablePromptKey.VivaEngageRebrandingNonAdminBanner
  );

  const isRebrandingAlreadyEnabled = !!useExperimentTreatmentWithoutReporting(Experiment.VivaEngageRebranding);

  if (isRebrandingAlreadyEnabled) {
    return false;
  }

  return isRegularBannerExperimentEnabled && shouldStartRegularBannerPrompt;
};
